import React from 'react';
import JobTable from './JobTable.js';
import * as Fuse from 'fuse.js';

class FilterFrame extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
                        data : props.data,
                        FilterKeyword: ""
        };
        //Options and fuse are not stateful so it is best practice to avoid putting it in this.state.
        this.options = {
              shouldSort: true,
              tokenize: true,
              threshold: 0.3,
              location: 0,
              distance: 100,
              maxPatternLength: 32,
              minMatchCharLength: 2,
            keys: [
                    "Title",
                    "Description",
                    "Location",
                    "Hours",
                    "Industry"
            ]
        };

        this.fuse = new Fuse(this.props.data, this.options);
        this.searchHandle = this.searchHandle.bind(this);
    }

    searchHandle(event){
        this.setState({FilterKeyword: event.target.value, data : this.fuse.search(event.target.value)});
        // console.log(this.state.data);
    }

    render() {
        //If the search box is filled, send JobTable our stateful fuse search results. Else, send over our static json prop data.
        return (
            <div>
            {Object.entries(this.state.data).length !== 0 && <div className="searchDiv"> Search: <input type="text" value={this.state.FilterKeyword} onChange={this.searchHandle}/></div>}
                <JobTable data={(this.state.FilterKeyword.trim() !== "") ? this.state.data : this.props.data}></JobTable>
            </div>);
    }

}
export default FilterFrame;
